import type { AstroLocale } from '@/schemas/components/shared/i18n';

interface InputLabels {
  anythingElse: Record<AstroLocale, string>;
  companyName: Record<AstroLocale, string>;
  companySize: Record<AstroLocale, string>;
  country: Record<AstroLocale, string>;
  email: Record<AstroLocale, string>;
  emailMarketing: Record<AstroLocale, string>;
  firstName: Record<AstroLocale, string>;
  howCanWeHelp: Record<AstroLocale, string>;
  howDidYouHearAboutUs: Record<AstroLocale, string>;
  industry: Record<AstroLocale, string>;
  jobTitle: Record<AstroLocale, string>;
  lastName: Record<AstroLocale, string>;
  name: Record<AstroLocale, string>;
  phoneCountryCode: Record<AstroLocale, string>;
  phoneNumber: Record<AstroLocale, string>;
  province: Record<AstroLocale, string>;
  state: Record<AstroLocale, string>;
  submit: Record<AstroLocale, string>;
  support: Record<AstroLocale, string>;
}

export const INPUT_LABELS: InputLabels = {
  anythingElse: {
    en: 'Is there anything else we should know?',
    fr: 'Y a-t-il autre chose que nous devrions savoir ?',
    de: 'Gibt es noch etwas, das wir wissen sollten?',
    es: '¿Hay algo más que deberíamos saber?',
    nl: 'Is er nog iets dat we zouden moeten weten?',
    zh: '还有什么需要我们了解的吗？',
  },
  companyName: {
    en: 'Company name',
    fr: 'Entreprise',
    de: 'Unternehmen',
    es: 'Empresa',
    nl: 'Bedrijf',
    // TODO: Add translation for zh
    zh: '公司​',
  },
  companySize: {
    // TODO: Add missing translations
    en: 'Company size',
    fr: '',
    de: '',
    es: '',
    nl: '',
    zh: '公司规模',
  },
  country: {
    en: 'Country',
    fr: 'Pays',
    de: 'Land',
    es: 'País',
    nl: 'Land',
    // TODO: Add translation for zh
    zh: '您所在的国家或地区',
  },
  email: {
    en: 'Email',
    fr: 'E-mail',
    de: 'E-Mail',
    es: 'Correo electrónico',
    nl: 'E-mail',
    // TODO: Add translation for zh
    zh: '电子邮件',
  },
  emailMarketing: {
    en: 'Subscribe to our email marketing communications',
    fr: 'Abonnez-vous à notre blog pour découvrir nos tout derniers insights en matière de gestion du capital humain et de la paie',
    de: 'Abonnieren Sie unseren Blog, um die neuesten Informationen zu Personalmanagement und Payroll zu erhalten.',
    es: 'Suscríbete a nuestro blog para recibir información actualizada sobre la gestión de trabajadores y nóminas',
    nl: 'Schrijf u in op ons blog voor de nieuwste inzichten op het gebied van personeel en loonlijstadministratie',
    // TODO: Add translation for zh
    zh: '订阅我们的电子邮件营销通讯',
  },
  name: {
    en: 'name',
    fr: '',
    de: '',
    es: 'nombre',
    nl: '',
    zh: '姓名',
  },
  firstName: {
    en: 'First name',
    fr: 'Prénom',
    de: 'Vorname',
    es: 'Nombre',
    nl: 'Voornaam',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  howCanWeHelp: {
    en: 'How can we help?',
    fr: 'Que pouvons-nous faire pour vous?',
    de: 'Wie können wir helfen?',
    es: '¿Cómo podemos ayudarte?',
    nl: 'Hoe kunnen we u helpen?',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  howDidYouHearAboutUs: {
    en: 'How did you hear about us?',
    fr: 'Comment avez-vous entendu parler de nous ?',
    de: 'Wie haben Sie von uns gehört?',
    es: '¿Cómo nos has conocido?',
    nl: 'Hoe heb je van ons gehoord?',
    // TODO: Add translation for zh
    zh: '您是怎么知道我们的*​',
  },
  industry: {
    en: '',
    fr: '',
    de: '',
    es: '',
    nl: '',
    zh: '行业',
  },
  jobTitle: {
    en: '',
    fr: '',
    de: '',
    es: '',
    nl: '',
    zh: '职位',
  },
  lastName: {
    en: 'Last name',
    fr: 'Nom',
    de: 'Nachname',
    es: 'Apellido',
    nl: 'Achternaam',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  phoneCountryCode: {
    en: 'Country code',
    fr: 'Code pays',
    de: 'Ländervorwahl',
    es: 'Código de país',
    nl: 'Landcode',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  phoneNumber: {
    en: 'Phone number',
    fr: 'Téléphone',
    de: 'Telefon',
    es: 'Teléfono',
    nl: 'Telefoon',
    // TODO: Add translation for zh
    zh: '联系电话',
  },
  province: {
    en: 'Which province are you located in?',
    fr: 'Dans quel provincie vous trouvez-vous ?',
    de: 'In welchem Provinz befinden Sie sich?',
    es: 'En qué provincia te encuentras?',
    nl: 'In welk provincie bevindt u zich?',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  state: {
    en: 'Which state are you located in?',
    fr: 'Dans quel état vous trouvez-vous ?',
    de: 'In welchem Bundesstaat befinden Sie sich?',
    es: 'En qué estado te encuentras?',
    nl: 'In welk staat bevindt u zich?',
    // TODO: Add translation for zh
    zh: '您所在的国家或地区',
  },
  submit: {
    en: 'Submit',
    fr: 'Envoyer',
    de: 'Senden',
    es: 'Enviar',
    nl: 'Indienen',
    // TODO: Add translation for zh
    zh: '提交',
  },
  support: {
    en: 'Please select one option',
    fr: 'Veuillez sélectionner une option',
    de: 'Bitte wählen Sie eine Option',
    es: 'Por favor selecciona una opcion',
    nl: 'Selecteer een optie',
    // TODO: Add translation for zh
    zh: '请选择一个选项',
  },
};
